module.exports = __webpack_public_path__ + "static/media/3a_website_logo_coorg_acm.2d44c965.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3a_website_logo_coorg_acm.jpg
// module id = 41
// module chunks = 0